module.exports = __webpack_public_path__ + "img/loader.dc8f9def.svg";